export interface Rng {
  next(): number;
}

export class FakeRng implements Rng {
  private idx = 0;
  constructor(private readonly values: number[]) {}
  next(): number {
    const v = this.values[this.idx % this.values.length] ?? 0;
    this.idx++;
    return v;
  }
}

export class SystemRng implements Rng {
  next(): number {
    return Math.random();
  }
}
